/**
 * Decides what a detail sheet's "Delete" confirmation should do.
 *
 * Detail sheets (Company/Person) always render a Delete action, but the actual
 * deletion used to only happen when a parent passed an `onDelete` prop — which
 * only two pages did. Everywhere else the button silently closed the sheet
 * without deleting anything. This helper makes the fallback explicit and
 * testable so the sheet works from every surface:
 *
 * - 'parent' — a parent handler owns the delete + list reconciliation.
 * - 'self'   — no parent handler, so the sheet deletes the entity itself.
 * - 'noop'   — nothing to delete (no id), or preview mode with no parent
 *              handler (don't fire a real mutation against dummy data).
 */
export function resolveSheetDeleteAction(opts: {
  id?: string | null;
  hasParentHandler: boolean;
  isPreview: boolean;
}): 'parent' | 'self' | 'noop' {
  if (!opts.id) return 'noop';
  if (opts.hasParentHandler) return 'parent';
  if (opts.isPreview) return 'noop';
  return 'self';
}
